import { maybeLog } from '../utils';
// import { apolloService } from '../../services';

/**
 * Intended to be triggered when a course is launched. This event will actually
 * handle the launching of a course.
 */
export async function viewResource( { courseId, resourceId, debug = false } ) {
    // Validate incomming parameter data.
    const isValidCourseId = Boolean( courseId );
    const isValidResourceId = Boolean( courseId );

    maybeLog( debug, `Attempting to view resource '${ resourceId }' from course '${ isValidResourceId }'.` );

    if ( isValidCourseId && isValidResourceId ) {
        let courseDetails = undefined; //apolloService.cache.readQuery( { query: SINGLE_COURSE_QUERY } );
        let resourceDetails = courseDetails
            ? courseDetails.resources.find( ( resource ) => ( resource.id === resourceId ) )
            : undefined;

        let doesCourseExist = Boolean( courseDetails );
        let doesResourceExist = Boolean( resourceDetails );

        // If we don't already have the desired resource details, attempt to retrieve
        // more information on the course.
        if ( !doesResourceExist ) {
            // If the course details don't exist in cache, attempt to fetch course details
            // using course id from our back-end.
            if ( !doesCourseExist ) {
                // TODO: Attempt to fetch course details using course id from our back-end.
                // ...
                courseDetails = undefined;
                doesCourseExist = false;
            }

            // If we have successfully retrieved course details, attempt to pull the resource
            // data out of the course data.
            if ( doesCourseExist ) {
                resourceDetails = courseDetails
                    ? courseDetails.resources.find( ( resource ) => ( resource.id === resourceId ) )
                    : undefined;

                doesResourceExist = Boolean( resourceDetails );
            }
        }

        // If data for the level was successfully retrieved, launching and tracking
        // can proceed.
        if ( doesResourceExist ) {
            maybeLog( debug, `Resource found with id '${ resourceId }'. Downloading...` );

            // TODO: Remove this forced delay used to mimic some loading time.
            await new Promise( resolve => setTimeout( resolve, 1500 ) );

            // Grab the resource url and open/download the file.
            const resourceUrl = resourceDetails?.url;
            if ( resourceUrl ) {
                const tokens = resourceUrl.split( '.' );
                const resourceExtension = tokens[ tokens.length + 1 ];

                switch ( resourceExtension ) {
                    case 'pdf': {
                        // Open the PDF resource in a new browser tab.
                        window.open( resourceUrl, '_blank' );
                        return true;
                    }
                    default: {
                        // Trigger a browser download of the resource file.
                        // ...

                        return true;
                    }
                }
            }

            // Return `true` to signify that the course managed to successfully launch.
            return true;
        }
        else {
            console.warn( `Resource with id '${ resourceId }' could not be found for some reason.` );

            // If nothing else happened, return `false` to signify that the course with
            // the provided id failed to launch.
            return false;
        }
    }
    else {
        console.warn( `Failed to retrieve resource with id '${ resourceId }'. ${ 
            !( !isValidCourseId && !isValidResourceId ) ? !isValidCourseId
                /* Invalid Course ID */ ? (
                    `The provided course id '${ courseId }' is considered to be invalid.`
                )
                /* Invalid Resource ID */ : (
                    `The provided resource id '${ resourceId }' is considered to be invalid.`
                )
                /* Both Invalid */ : (
                    `Both the course id (${ courseId }) and the resource id (${ resourceId }) are considered to be invalid.`
                )
         }` );

        // If nothing else happened, return `false` to signify that the course with the
        // provided id failed to launch.
        return false;
    }
}
